(function(){
  var h=document.getElementById('hdr');
  if(h){window.addEventListener('scroll',function(){h.classList.toggle('solid',window.scrollY>window.innerHeight*0.7);});}
  function initCarousel(){
    var t=document.getElementById('ctrack');
    if(!t)return;
    function step(){var s=t.querySelector('.slide');return s?s.getBoundingClientRect().width+16:t.clientWidth*0.86;}
    function atEnd(){return t.scrollLeft+t.clientWidth>=t.scrollWidth-8;}
    function atStart(){return t.scrollLeft<=8;}
    var nx=document.querySelector('.cnav.next'),pv=document.querySelector('.cnav.prev');
    if(nx)nx.onclick=function(){atEnd()?t.scrollTo({left:0,behavior:'smooth'}):t.scrollBy({left:step(),behavior:'smooth'});};
    if(pv)pv.onclick=function(){atStart()?t.scrollTo({left:t.scrollWidth,behavior:'smooth'}):t.scrollBy({left:-step(),behavior:'smooth'});};
  }
  function initAcc(){
    document.querySelectorAll('.acc-h').forEach(function(b){
      if(b.dataset.accReady==='1')return;
      b.dataset.accReady='1';
      b.setAttribute('aria-expanded','false');
      b.addEventListener('click',function(){
        var it=b.parentElement,open=it.classList.contains('open');
        it.classList.toggle('open');
        var pm=b.querySelector('.pm');
        if(pm)pm.textContent=open?'+':'–';
        b.setAttribute('aria-expanded',open?'false':'true');
      });
    });
  }
  function initDrawer(){
    var b=document.querySelector('.ffnav-burger'),dr=document.getElementById('ffnav-drawer'),sc=document.querySelector('.ffnav-scrim'),cl=document.querySelector('.ffnav-close');
    if(!b||b.dataset.drReady==='1')return;
    b.dataset.drReady='1';
    var root=document.documentElement;
    function set(o){root.classList.toggle('ffnav-open',o);b.setAttribute('aria-expanded',o?'true':'false');}
    b.addEventListener('click',function(){set(!root.classList.contains('ffnav-open'));});
    if(sc)sc.addEventListener('click',function(){set(false);});
    if(cl)cl.addEventListener('click',function(){set(false);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')set(false);});
    if(dr)dr.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){set(false);});});
  }
  function initAll(){initCarousel();initAcc();initDrawer();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
